import "./App.css";
import logo from './logo.png'

function App() {
  const lastUpdated = "June 2026";

  return (
    <div className="container">
      <header className="header">
         <img src={logo} alt="Absolute Safety Logo" className="company-logo"/>
        <h1>Privacy Policy</h1>
        <p className="subtitle">
          Last Updated: {lastUpdated}
        </p>
      </header>

      <section>
        <h2>Introduction</h2>
        <p>Absolute Safety Associates is one the entity under Absolute Safety Group. We provide unparalleled service and solutions for Technical & Commercial evaluation of the assets and businesses. We have knowledge and experience for all aspects i.e., inspection, testing & certification needs of a clie nt inthis domain.We have in-depth expertise in inspection and testing of equipment (Cranes, Hoists, Lifters, Chains,Fork- lifts etc.) and Pressure Plant (Pressure vessels, Pipelines, Safety Valves etc.) for ascertaining theirsafe operating condition.We have specialization in Industrial Safety and Non-Destructive Testing. In addition, we have a teamof qualified professionals and experts with over a decade of experience in Lifting Equipment and Pressure Plant technology.</p>
      <h3>OUR SERVICES</h3>
      <p>As an Approved Competent Person with different states, we are authorized for providing services of carrying outs tests, examinations, inspections and certifications for the following aspects of factory act 1948 under Sections 28, 29 & 31.</p>
        <ul>
          <li>Visual Inspection and Certification</li>
          <li>Inspection and Load Testing</li>
          <li>Hydraulic Testing</li>
          <li>Non-Destructive Test (NDT)</li>
          <li>Safety Audits</li>
          <li>Calibration</li>
        </ul>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <p>To provide and improve our services, we may collect the following information from users:</p>
        <h3>Personal Information</h3>
        <ul>
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Mobile Phone Number</li>
        </ul>
         <h3>Authentication Information</h3>
         <p>When you sign in to our application, we use Firebase Authentication to verify your mobile phone number through a one-time password (OTP) verification process. Upon successful verification, we authenticate your account with our backend services to provide access to application features.

We only collect information that is necessary to provide our services, manage user accounts, and communicate with users regarding their use of the application.</p>

      </section>

      <section>
        <h2>How We Use Information</h2>
        <p>We use the information we collect for the following purposes:</p>

        <ul>
          <li>To create and manage user accounts.</li>
          <li>To verify user identity and authenticate access to our services.</li>
          <li>To provide, maintain, and improve application functionality.</li>
          <li>To communicate important account-related information and service updates.</li>
          <li>To provide customer support and respond to user inquiries.</li>
          <li>To enhance the security, reliability, and performance of our services.</li>
          <li>To comply with applicable legal and regulatory requirements.</li>
        </ul>
        <p>We do not use your personal information for purposes that are unrelated to the operation and improvement of our services without obtaining appropriate consent where required.</p>
      </section>

      <section>
        <h2>Data Sharing</h2>
        <p>
          We value your privacy and do not sell, rent, or trade your personal information to third parties. We may share information only in the following circumstances:
        </p>
        <h3>Service Providers</h3>
        <p>We use trusted third-party service providers, such as Firebase Authentication, to facilitate secure user authentication and support application functionality.</p>
        <h3>Legal Requirements</h3>
        <p>We may disclose information if required to do so by law, regulation, legal process, or governmental request.</p>
        <h3>Business Operations</h3>
        <p>In the event of a merger, acquisition, restructuring, or sale of assets, user information may be transferred as part of the business transaction, subject to applicable privacy obligations. Any third-party service providers that process personal information on our behalf are required to maintain appropriate security and confidentiality measures.</p>
      </section>

      <section>
        <h2>Data Security</h2>
        <p>We take reasonable technical, administrative, and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, misuse, or destruction.</p>
        <p>Our security practices include:</p>
        <ul>
          <li>Secure user authentication through Firebase Authentication.</li>
          <li>Encrypted communication between the mobile application and backend services using industry-standard security protocols.</li>
          <li>Access controls to restrict unauthorized access to user information.</li>
          <li>Regular monitoring and maintenance of our systems to enhance security and reliability.</li>
        </ul>
        <p>While we strive to protect your information using commercially reasonable safeguards, no method of electronic transmission or storage is completely secure. Therefore, we cannot guarantee absolute security of your information.</p>
      </section>

       <section>
        <h2>Data Retention</h2>
        <p>We take reasonable technical, administrative, and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, misuse, or destruction.</p>
        <br/>
        <h2>Delete Your Personal Information</h2>
        <p>We will automatically delete your personal information after 90 days. Still if you want to delete it earlier, please contact us at:</p>
         <p>Email: absolutesafety2021@gmail.com <br/> Contact: +91 930 956 4790</p>
         <h2>Step To Delete Your Personal Information:</h2>
         <p>
           <ul>
          <li>Step 1: Contact us via email or phone to request deletion of your personal information.</li>
          <li>Step 2: Provide necessary identification and verification details.</li>
          <li>Step 3: Wait for our confirmation and completion of the deletion process.</li>
          <li>Step 4: Receive a confirmation email once your personal information is deleted.</li>
        </ul>
         </p>
       </section>
      <section>
        <h2>Contact Us</h2>
        <h3>If you have any questions about this Privacy Policy or our data practices, please contact us at:</h3>
        <p>
          Email: absolutesafety2021@gmail.com  <br/> Contact: +91 930 956 4790
        </p>
      </section>

      <footer>
        © 2026 Absolute Safety
      </footer>
    </div>
  );
}

export default App;